import {put, select, takeLatest} from 'redux-saga/effects';
import {getAnalyticsV3Api} from 'helpers/services/api/analytics';
import {
  normalizeCustomersCount,
  unwrapAnalyticsPayload
} from 'helpers/services/api/analyticsHelpers';
import {GET_CUSTOMERS_COUNT, GET_CUSTOMERS_COUNT_SUCCESS} from './action';

function* getCustomersCount({payload}) {
  try {
    const {locationId} = yield select((state) => state.user);
    const response = yield getAnalyticsV3Api(locationId, {
      startDate: payload.startDate,
      endDate: payload.endDate,
      channelTypes: payload.channelTypes,
      fulfillmentModes: payload.fulfillmentModes,
      includeSalesPerItem: false,
      includeKpi: true,
      includePerHoursStatistics: false
    });
    const data = normalizeCustomersCount(unwrapAnalyticsPayload(response));
    yield put(
      GET_CUSTOMERS_COUNT_SUCCESS(data && Object.keys(data).length ? data : {})
    );
  } catch (error) {
    yield put(GET_CUSTOMERS_COUNT_SUCCESS({}));
    console.log('SAGA ERROR', error);
  }
}

function* analyticsCustomersCountSaga() {
  yield takeLatest(GET_CUSTOMERS_COUNT, getCustomersCount);
}

export default analyticsCustomersCountSaga;
